import triggerQuantityChange from '../helpers/qty-change';
import addToCartVariation from './add-to-cart-variation';
import variableProductPricesHide from './variable-product-prices-hide';
import $ from 'jquery';

(function (document, $, undefined) {

	const productPage = {};

	productPage.init = function () {
		this.triggerQuantityChange();
		this.addToCartVariation();
		if ($('.variations_form').length) {
			variableProductPricesHide();
		}
	};

	productPage.triggerQuantityChange = function () {
		triggerQuantityChange();
	};

	productPage.addToCartVariation = function () {
		addToCartVariation();
	};

	$(document).ready(function () {
		productPage.init();
		// setTimeout(function () {
		// 	const variationInput = $(
		// 		".variations_form input[name='variation_id']"
		// 	);
		// 	if (variationInput.val() === '0') {
		// 		$('.add_to_cart_button').attr('disabled', true);
		// 	}
		// }, 1000);
	});
})(document, jQuery);
